import { UPLOAD_CONTENT_TYPES, UPLOAD_MAX_BYTES } from "@storyai/shared";

/** Client-side pre-check before an image upload. Returns an error message or null. */
export function validateImageFile(file: { type: string; size: number }): string | null {
  if (!(UPLOAD_CONTENT_TYPES as readonly string[]).includes(file.type)) {
    return "Use a PNG, JPEG, WebP, or GIF image.";
  }
  if (file.size > UPLOAD_MAX_BYTES) {
    return `Image is too large (max ${Math.round(UPLOAD_MAX_BYTES / (1024 * 1024))} MB).`;
  }
  return null;
}
